import teamFeedReducer from './reducers';

export { default as teamFeedActions } from './actions';
export { default as teamFeedOperations } from './operations';
export { default as teamFeedShapes } from './shapes';
export { default as teamFeedSelectors } from './selectors';

export default teamFeedReducer;
